import axios from '@/util/requestUtil'

class SubAccount {
  getsubAccount (params) {
    return axios.get(`/fund/sub-account/home`, params)
  }
  getsubAccountRecord (params) {
    return axios.get(`/fund/sub-account/application/records`, params)
  }
  commitSubAccout (params) {
    return axios.post(`/fund/sub-account/application`, params)
  }
}

export default new SubAccount()
